/*Mahesh S  : 05-10-2023 : BT-105135 -  Breeze- Portfolio Holdings - Start*/
import { memo, forwardRef, useMemo, useCallback, useState, useEffect } from "react";
import { Col, Container, Dropdown, Row } from "react-bootstrap";
import { BzMasterAgGrid, BzChip, BzToolTip } from '../../../components';
import HoldingGridDetails from "./HoldingGridDetails";
import { HOILDING_GRID_REF, convertScripResponseWatchlistGrid, displayZeroStateForGrid, getAppInfoData, handleScripUnsubScriptionOnUnMount, deepClone, bIsProd, convertTOVariable, convertColumnsDatatoGridColumns } from "../../../utils/global_functions";
import HoldingsPopover from "../HoldingsPopover";
import { _percentChange } from "../../../controllers/holdings";
import ZeroStates from "../../ZeroStates";
import { APP_INFO_PARAMS, WATCHLIST_GRID_INDEX, MULTIPLIER, TL_INDEX, LAYOUT_TYPE, HEATMAP_COLURS, PROFIT_GROUP, LOSS_GROUP, GRID_VIEW, CRORE, MANAGE_COLUMNS_VIEW_TYPES, DEFAULT_MANAGE_COLUMN_PROFILE_NAME } from "../../../utils/global_variables";
import { useDispatch, useSelector } from "react-redux";
import GridHeaderSearch from "../../GridHeaderSearch";
import { PriceVolumeView, WatchlistShareModal } from "../../Watchlist";
import { handleModal } from "../../../redux/actions/modals";
import { getWfhTouchlineLastTick } from '../../../redux/actions/wfh';
import HeatmapView from "../../MarketOverview/HeatmapView";
import { sendTouchlineRequest } from "../../../apis/web_socket";
import { updateHoldingView } from "../../../redux/actions/holdings";
import { updateDefaultManageColumnName, updateStrViewType } from "../../../redux/actions/watchlist";
import { useUnload } from "../../../hooks";


const HoldingsSymbolContent = (props) => {

    const { data } = props;

    const { dontMissData } = useSelector(state => state.dontMiss);

    return (
        <>
            {/* ManasaB : 13-06-2024 : Changed to left click in grid : End */}
            {
                dontMissData.some(element => element[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === data?.nMarketSegmentId + '_' + data?.nToken)
                    ? <div className='normal-scrip dontmiss-scrip'></div> : null
            }
            <div className='d-flex align-items-center'>
                <span className='font-medium font-enlarge color-text text-uppercase ms-2'>{props.value}</span>
                {/* Prachi T - 05-12-2023 - BT-109052 - Breeze- Font and Colour Settings */}
                {/* <span className='icon-16 icon-dontmiss icon-yellow ms-2'></span> */}
                {
                    dontMissData.some(element => element[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === data?.nMarketSegmentId + '_' + data?.nToken)
                        ? <div className='icon-16 icon-dontmiss icon-yellow ms-2'></div> : null
                }
            </div>
        </>
    );
};



const CustomDropdownToggle = forwardRef(({ children, onClick, className }, ref) => (
    <div
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
    >
        {children}
    </div>
));

const HoldingsGrid = ({ handleExpandHoldings, isMasterDetail, handleCreateWatchlist, isGlobalSearch,
    isSuppressMenu, arrGridRowData, toggleTabs, gridDetailCellRenderer, setIsShowHoldingsFilterModelsModal,
    isShowHoldingsFilterModelsModal, handleDelete, temp, tempFilter, heatMapToggle, setHeatMapToggle,
    activeButtonToggleIndex, setActiveButtonToggleIndex, heatmapChartConfig, activePage, gridRef, ...props }) => {
    const dispatch = useDispatch();
    const [bScroll, setbScroll] = useState(false);
    const ExtendHoldings = useMemo(() => HoldingGridDetails, []);
    const getHoldingssRowId = useCallback((params) => {
        return params.data['segmentIdToken'];
    }, []);

    // Hari k:24-07-2024 : holdings-price volume view-start
    const holdingsScrips = useSelector(state => state?.holdings?.holdingsScrips);
    const holdingsView = useSelector(state => state.portfolio?.holdingsView);
    const [arrWatchlistData, setArrWatchlistData] = useState([]);
    const [arrcombinedData, setArrcombinedData] = useState([]);
    const [strSearchScrip, setStrSearchScrip] = useState('');
    const [isLoader, setIsLoader] = useState(false);
    const [arrHeatmap, setArrHeatmap] = useState([]);
    const [activeHoldings, setActiveHoldings] = useState({});
    const [objScripsRequest, setObjScripsRequest] = useState({});
    // Hari k:24-07-2024 : holdings-price volume view - end

    // Hari K: have to define holdingsColumnProfiles usememo function to get holding colunm def profile
    const userColumnProfiles = useSelector(state => state?.watchList?.userColumnProfiles);
    const objViewWiseColumnProfiles = useSelector(state => state.watchList.objViewWiseColumnProfiles);
    const holdingsTenantColumnProfiles = useMemo(() => {
        const holdingsColumDetails = deepClone(userColumnProfiles)?.find(eachProfile => eachProfile?.sViewType?.toLowerCase() === MANAGE_COLUMNS_VIEW_TYPES?.HOLDINGS_VIEW_TYPE?.toLowerCase() && eachProfile?.bIsDefault);
        let settings = {};
        if (holdingsColumDetails) {
            const updatedColumnDetails = deepClone(holdingsColumDetails?.columnDetails)?.map((eachProfile) => {
                if (typeof eachProfile.sSettings === 'string') {
                    settings = JSON?.parse(eachProfile?.sSettings);
                } else {
                    settings = { ...eachProfile?.sSettings };
                }
                eachProfile.sSettings = { ...settings, field: typeof settings?.field === "number" ? settings?.field.toString() : convertTOVariable(settings?.field) };
                return eachProfile;
            });
            return convertColumnsDatatoGridColumns(updatedColumnDetails);
        } else {
            const updatedColumnDetails = objViewWiseColumnProfiles[MANAGE_COLUMNS_VIEW_TYPES.HOLDINGS_VIEW_TYPE]?.map((eachProfile) => {
                if (typeof eachProfile.sSettings === 'string') {
                    settings = JSON?.parse(eachProfile?.sSettings);
                } else {
                    settings = { ...eachProfile?.sSettings };
                }
                eachProfile.sSettings = { ...settings, field: typeof settings?.field === "number" ? settings?.field.toString() : convertTOVariable(settings?.field) };
                return eachProfile;
            });
            const arrdDefaultColumns = updatedColumnDetails?.filter(eachColumn => eachColumn?.sSettings?.bIsFixed === "true" || eachColumn?.sSettings?.bIsDefault === "true");
            return convertColumnsDatatoGridColumns(arrdDefaultColumns);
        }
    }, [userColumnProfiles, objViewWiseColumnProfiles]);
    function getColor(value) {
        if (value === PROFIT_GROUP.ZERO) { return HEATMAP_COLURS.GRAY; }
        else if (value >= PROFIT_GROUP.TWO) { return HEATMAP_COLURS.GREEN; }
        else if (value >= PROFIT_GROUP.ONE) { return HEATMAP_COLURS.FERN_GREEN; }
        else if (value > PROFIT_GROUP.ZERO) { return HEATMAP_COLURS.FRUIT_SALAD; }
        else if (value >= LOSS_GROUP.MINUS_ONE) { return HEATMAP_COLURS.RED_DAREN; }
        else if (value >= LOSS_GROUP.MINUS_TWO) { return HEATMAP_COLURS.RED; }
        else if (value < LOSS_GROUP.MINUS_TWO) { return HEATMAP_COLURS.MANCHESTER_NIGHTS; }
    }

    // {/* Azeem K : 19-12-2023 :BT-102298 : NSEEQ Holdings  ---Start */ }

    const appInfo = useSelector(state => state.appInfo.appInfo);
    const strHoldingMsg = getAppInfoData(APP_INFO_PARAMS.APP_AVG_PRICE_DISCLAIMER, appInfo);
    // {/* Azeem K : 19-12-2023 :BT-102298 : NSEEQ Holdings  ---End */ }
    const handleScrolling = (event) => {
        if (event?.direction === LAYOUT_TYPE.HORIZONTAL && event?.left > 30) {
            setbScroll(true);
        } else if (event?.direction === LAYOUT_TYPE.VERTICAL) {
            handleVisibleRows();
        } else {
            setbScroll(false);
        }
    };

    useEffect(() => {
        //BT-141551 : Heatmap View : ManasaB : 23-08-2024 - Start
        // if (Object.keys(activeHoldings)?.length === 0) {
        setIsLoader(true);
        // if (holdingsView !== GRID_VIEW.DEFAULT_VIEW) {
        //     setArrHeatmap([])
        // }
        setTimeout(() => {
            if (arrHeatmap?.length === 0) {

                /* Deepti B[23/10/2024]: useEffect will call on changing holding view and flushing heatmap array to load heatmap tile data
                added market capitalization under Scrip name and valuation on heatmap tile */
                setArrHeatmap([]);
                const objLastTickData = dispatch(getWfhTouchlineLastTick());
                let equityHoldings = [];
                let arrTempHeatmapData = [];
                // Vinit R : BT-117136: 16-07-24: Holdings - Heatmap View -- Start
                holdingsScrips?.forEach((holding, index) => {
                    if (holding?.ScripData?.length > 0 && holding?.ScripData[0]?.sInstrumentName === 'EQUITIES') {
                        equityHoldings.push(holding);
                    }
                });
                // Vinit R : BT-117136: 16-07-24: Holdings - Heatmap View -- End

                // {/* Vinit Raut [14-05-2024] - BT-117136 - Holdings - Heatmap View - Start */ }
                let allTileSizes = [];
                equityHoldings.forEach(e => {
                    const segmentIdToken = e.nMarketSegmentId + '_' + e.nToken;
                    if (objLastTickData[segmentIdToken]) {
                        allTileSizes.push(parseFloat((e?.ScripData[0]?.nIssuedCapital * objLastTickData[segmentIdToken][TL_INDEX.CLOSE_PRICE]) / MULTIPLIER.THOUSAND_CRORES));
                    }
                    else {
                        allTileSizes.push(parseFloat((e?.ScripData[0]?.nIssuedCapital * e?.ScripData[0]?.nIssuedCapital) / MULTIPLIER.THOUSAND_CRORES));
                    }
                });
                const maxTileSize = allTileSizes?.reduce((prev, current) => {
                    return prev > current ? prev : current;
                }, 0);
                const breakpointSize = parseFloat(maxTileSize / MULTIPLIER.HUNDRED);
                // {/* Vinit Raut [14-06-2024] - BT-117136 - Holdings - Heatmap View - End */ }

                if (heatMapToggle === 0) {
                    equityHoldings.forEach((e, i) => {
                        const segmentIdToken = e.nMarketSegmentId + '_' + e.nToken;

                        if (objLastTickData[segmentIdToken]) {
                            arrTempHeatmapData.push({
                                name: e?.sSymbol,
                                id: segmentIdToken,
                                valuation: parseFloat(objLastTickData[segmentIdToken][TL_INDEX.LAST_TRADE_PRICE]),
                                change: parseFloat(objLastTickData[segmentIdToken][TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE]),
                                size: parseFloat((e?.ScripData[0]?.nIssuedCapital * objLastTickData[segmentIdToken][TL_INDEX.CLOSE_PRICE]) / MULTIPLIER.THOUSAND_CRORES) > breakpointSize
                                    ? parseFloat((e?.ScripData[0]?.nIssuedCapital * objLastTickData[segmentIdToken][TL_INDEX.CLOSE_PRICE]) / MULTIPLIER.THOUSAND_CRORES)
                                    : breakpointSize, // Vinit Raut [14-05-2024] - BT-117136 - Holdings - Heatmap View
                                color: getColor(parseFloat(objLastTickData[segmentIdToken][TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE])),
                                marketCap: `${parseFloat((e?.ScripData[0]?.nIssuedCapital * objLastTickData[segmentIdToken][TL_INDEX.CLOSE_PRICE]) / MULTIPLIER.THOUSAND_CRORES).toFixed(2)} ${CRORE}`
                            });
                        }
                        else {
                            arrTempHeatmapData.push({
                                name: e?.sSymbol,
                                id: segmentIdToken,
                                valuation: e?.PandL,
                                change: parseFloat(e?.perPandL),
                                size: parseFloat((e?.ScripData[0]?.nIssuedCapital * e?.ScripData[0]?.nIssuedCapital) / MULTIPLIER.THOUSAND_CRORES) > breakpointSize
                                    ? parseFloat((e?.ScripData[0]?.nIssuedCapital * e?.ScripData[0]?.nIssuedCapital) / MULTIPLIER.THOUSAND_CRORES)
                                    : breakpointSize, // Vinit Raut [14-05-2024] - BT-117136 - Holdings - Heatmap View
                                color: getColor(parseFloat(e?.perPandL)),
                                marketCap: `${parseFloat((e?.ScripData[0]?.nIssuedCapital * e?.ScripData[0]?.nIssuedCapital) / MULTIPLIER.THOUSAND_CRORES).toFixed(2)} ${CRORE}`
                            });
                        }
                    });
                } else if (heatMapToggle === 1) {
                    equityHoldings.forEach((e, i) => {
                        const segmentIdToken = e.nMarketSegmentId + '_' + e.nToken;

                        if (objLastTickData[segmentIdToken]) {
                            if (arrTempHeatmapData.findIndex((x) => x.name === (e?.ScripData[0]?.sSector === "" ? "Other" : e?.ScripData[0]?.sSector)) === -1) {
                                arrTempHeatmapData.push({
                                    id: segmentIdToken,
                                    sector: (e?.ScripData[0]?.sSector === "" ? "Other" : e?.ScripData[0]?.sSector).toUpperCase(),
                                    name: e?.sSymbol,
                                    valuation: parseFloat(objLastTickData[segmentIdToken][TL_INDEX.LAST_TRADE_PRICE]),
                                    change: parseFloat(objLastTickData[segmentIdToken][TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE]),
                                    size: parseFloat((e?.ScripData[0]?.nIssuedCapital * objLastTickData[segmentIdToken][TL_INDEX.CLOSE_PRICE]) / MULTIPLIER.THOUSAND_CRORES) > breakpointSize
                                        ? parseFloat((e?.ScripData[0]?.nIssuedCapital * objLastTickData[segmentIdToken][TL_INDEX.CLOSE_PRICE]) / MULTIPLIER.THOUSAND_CRORES)
                                        : breakpointSize, // Vinit Raut [14-05-2024] - BT-117136 - Holdings - Heatmap View
                                    color: getColor(parseFloat((objLastTickData[segmentIdToken][TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE])) / 10000000),
                                    marketCap: `${parseFloat((e?.ScripData[0]?.nIssuedCapital * objLastTickData[segmentIdToken][TL_INDEX.CLOSE_PRICE]) / MULTIPLIER.THOUSAND_CRORES).toFixed(2)} ${CRORE}`
                                });
                            }
                            else {
                                arrTempHeatmapData.push([{
                                    id: segmentIdToken,
                                    name: e?.sSymbol,
                                    valuation: parseFloat(objLastTickData[segmentIdToken][TL_INDEX.LAST_TRADE_PRICE]),
                                    change: parseFloat(objLastTickData[segmentIdToken][TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE]),
                                    size: parseFloat((e?.ScripData[0]?.nIssuedCapital * objLastTickData[segmentIdToken][TL_INDEX.CLOSE_PRICE]) / MULTIPLIER.THOUSAND_CRORES) > breakpointSize
                                        ? parseFloat((e?.ScripData[0]?.nIssuedCapital * objLastTickData[segmentIdToken][TL_INDEX.CLOSE_PRICE]) / MULTIPLIER.THOUSAND_CRORES)
                                        : breakpointSize, // Vinit Raut [14-05-2024] - BT-117136 - Holdings - Heatmap View
                                    color: getColor(parseFloat(objLastTickData[segmentIdToken][TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE])),
                                    marketCap: `${parseFloat((e?.ScripData[0]?.nIssuedCapital * objLastTickData[segmentIdToken][TL_INDEX.CLOSE_PRICE]) / MULTIPLIER.THOUSAND_CRORES).toFixed(2)} ${CRORE}`
                                }]);
                            }
                        }
                        else {
                            if (arrTempHeatmapData.findIndex((x) => x?.name === (e?.ScripData[0]?.sSector === "" ? "Other" : e?.ScripData[0]?.sSector)) === -1) {
                                arrTempHeatmapData.push({
                                    id: segmentIdToken,
                                    sector: (e?.ScripData[0]?.sSector === "" ? "Other" : e?.ScripData[0]?.sSector).toUpperCase(),
                                    name: e?.sSymbol,
                                    valuation: e?.PandL,
                                    change: parseFloat(e?.perPandL),
                                    size: parseFloat((e?.ScripData[0]?.nIssuedCapital * e?.ScripData[0]?.nIssuedCapital) / MULTIPLIER.THOUSAND_CRORES) > breakpointSize
                                        ? parseFloat((e?.ScripData[0]?.nIssuedCapital * e?.ScripData[0]?.nIssuedCapital) / MULTIPLIER.THOUSAND_CRORES)
                                        : breakpointSize, // Vinit Raut [14-05-2024] - BT-117136 - Holdings - Heatmap View
                                    color: getColor(parseFloat(e?.perPandL)),
                                    marketCap: `${parseFloat((e?.ScripData[0]?.nIssuedCapital * e?.ScripData[0]?.nIssuedCapital) / MULTIPLIER.THOUSAND_CRORES).toFixed(2)} ${CRORE}`
                                });
                            }
                            else {
                                arrTempHeatmapData.push([{
                                    id: segmentIdToken,
                                    name: e?.sSymbol,
                                    valuation: e?.PandL,
                                    change: parseFloat(e?.perPandL),
                                    size: parseFloat((e?.ScripData[0]?.nIssuedCapital * e?.ScripData[0]?.nIssuedCapital) / MULTIPLIER.THOUSAND_CRORES) > breakpointSize
                                        ? parseFloat((e?.ScripData[0]?.nIssuedCapital * e?.ScripData[0]?.nIssuedCapital) / MULTIPLIER.THOUSAND_CRORES)
                                        : breakpointSize, // Vinit Raut [14-05-2024] - BT-117136 - Holdings - Heatmap View
                                    color: getColor(parseFloat(e?.perPandL)),
                                    marketCap: `${parseFloat((e?.ScripData[0]?.nIssuedCapital * e?.ScripData[0]?.nIssuedCapital) / MULTIPLIER.THOUSAND_CRORES).toFixed(2)} ${CRORE}`
                                }]
                                );
                            }
                        }
                    });
                }

                if (equityHoldings?.length === 0) {
                    setActiveHoldings([]);
                    setArrHeatmap([]);
                    setIsLoader(false);
                    return;
                }
                setArrHeatmap(arrTempHeatmapData);
                setIsLoader(false);
            }
            setIsLoader(false);
        }, 500);
    }, [dispatch, heatMapToggle, holdingsScrips, activeHoldings]);

    let strSearch = null;

    const onChangeGridHeaderSearch = useCallback((e) => {
        strSearch = e?.target?.value;
        HOILDING_GRID_REF?.current?.api?.onFilterChanged();
        // Vinit R - 04-07-2024 -- Add zero state for AG grid -- Start
        displayZeroStateForGrid(HOILDING_GRID_REF);
        // Vinit R - 04-07-2024 -- Add zero state for AG grid -- End
    }, []);

    const isExternalFilterPresent = useCallback(() => {
        return strSearch !== null;
    }, []);

    const doesExternalFilterPass = useCallback(
        (node) => {
            if (!strSearch) {
                return true;
            } else {
                const keywords = strSearch?.toString()?.toLowerCase()?.split(' ');
                return node?.data?.sSymbol?.toLowerCase()?.includes(keywords);
            }
        },
        [strSearch]
    );

    //  Azeem K : 27-02-2024 : BT-102298 - Breeze - Single Scrip Order entry - BSEEQ Net Position sorting  - Start 

    const sortingComparator = useCallback((number1, number2) => {
        number1 = parseFloat(number1?.toString()?.replace(/,/g, ''));
        number2 = parseFloat(number2?.toString()?.replace(/,/g, ''));
        if (number1 === null) {
            return 0.00;
        }
        if (number2 === null) {
            return 0.00;
        }
        return number1 - number2;
    }, []);
    //  Azeem K : 27-02-2024 : BT-102298 - Breeze - Single Scrip Order entry - BSEEQ Net Position sorting  - End

    // have to changed column def according to manage columns
    // Hari k:01-10-2024: changed column def according to manage columns-start
    const arrHoldingsColumnDefs = useMemo(() => {
        if (holdingsTenantColumnProfiles?.length > 0) {
            const arrWatchlistColDefs = holdingsTenantColumnProfiles?.map(item => {
                switch (item?.field) {
                    case "detail": {
                        item = {
                            ...item,
                            cellRenderer: 'agGroupCellRenderer',
                            width: '50',
                            detailCellRendererParams: { placement: 'right' },
                            pinned: 'left',
                            suppressMovable: true,
                            lockPosition: "left",
                            suppressNavigable: true,
                            menuTabs: [],
                            cellStyle: { display: "flex", alignItems: "center", justifyContent: "center" },
                            flex: 1
                        };
                        return item;
                    }
                    case "sSymbol": {
                        item = {
                            ...item,
                            headerComponent: GridHeaderSearch,
                            // Azeem K : 19-12-2023 :BT-102298 : NSEEQ Holdings  ---Start 
                            cellRenderer: (props) => <HoldingsPopover {...props}><HoldingsSymbolContent {...props} /></HoldingsPopover>, minWidth: 200,
                            // Azeem K : 19-12-2023 :BT-102298 : NSEEQ Holdings  ---End 
                            cellRendererParams: { placement: toggleTabs ? 'right' : 'left', bScroll: bScroll },
                            headerComponentParams: { onChangeGridHeaderSearch, gridRef: HOILDING_GRID_REF, id: 'holdings_header_search_today' },
                            maxWidth: 150,
                            pinned: 'left',
                            suppressMovable: true,
                            lockPosition: "left",
                            suppressNavigable: true,
                        };
                        return item;
                    }
                    case "qty": {
                        item = {
                            ...item,
                            comparator: sortingComparator,
                            cellRenderer: (props) => <HoldingsPopover placement={'left'} {...props}>{props.value}</HoldingsPopover>,
                            maxWidth: 150,
                            // pinned: 'left',
                            suppressMovable: true,
                            // lockPosition: "left",
                            suppressNavigable: true,

                        };
                        return item;
                    }
                    case "perPandL": {
                        item = {
                            ...item,
                            cellClassRules: {
                                'color-positive': params => parseFloat(params?.value) > 0,
                                'color-negative': params => parseFloat(params?.value) < 0,
                                cellRenderer: (props) => <HoldingsPopover placement={'left'} {...props}>{props.value}</HoldingsPopover>,
                                valueFormatter: _percentChange,
                                comparator: sortingComparator,
                            }
                        };
                        return item;
                    }
                    case "nBuyAvgPriceDisplay": {
                        item = {
                            ...item,
                            comparator: sortingComparator,
                            cellRenderer: (props) => <HoldingsPopover placement={'left'} {...props}>{props.value}</HoldingsPopover>,
                        };
                        return item;
                    }
                    case "ltp": {
                        item = {
                            ...item, comparator: sortingComparator,
                            cellRenderer: (props) => <HoldingsPopover placement={'left'} {...props}>{props.value}</HoldingsPopover>,
                            cellClassRules: {
                                'background-positive color-active-text': params => params?.data?.ltpChange === 'U',   //Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes 
                                'background-negative color-active-text': params => params?.data?.ltpChange === 'D',   //Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes 
                                '': params => params?.data?.ltpChange === 'S',   //Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes 
                            },
                        };
                        return item;
                    }
                    case "CMV": {
                        item = {
                            ...item, comparator: sortingComparator,
                            cellRenderer: (props) => <HoldingsPopover placement={'left'} {...props}>{props.value}</HoldingsPopover>,
                        };
                        return item;
                    }
                    case "TodaysPandL": {
                        item = {
                            ...item,
                            cellClassRules: {
                                'color-positive': params => parseFloat(params?.value) > 0,
                                'color-negative': params => parseFloat(params?.value) < 0,
                            },
                            comparator: sortingComparator,
                            cellRenderer: (props) => <HoldingsPopover placement={'left'} {...props}>&#8377;{props.value}</HoldingsPopover>
                        };
                        return item;
                    }
                    case "perTodaysPandL": {
                        item = {
                            ...item,
                            cellClassRules: {
                                'color-positive': params => parseFloat(params?.value) > 0,
                                'color-negative': params => parseFloat(params?.value) < 0,
                            },
                            valueFormatter: _percentChange,
                            comparator: sortingComparator,
                            cellRenderer: (props) => <HoldingsPopover placement={'left'} {...props}>{props.value}</HoldingsPopover>
                        };
                        return item;
                    }
                    case "PandL": {
                        item = {
                            ...item,
                            cellClassRules: {
                                'color-positive': params => parseFloat(params?.value) > 0,
                                'color-negative': params => parseFloat(params?.value) < 0,
                            },
                            comparator: sortingComparator,
                            cellRenderer: (props) => <HoldingsPopover placement={'left'} {...props}>&#8377;{props.value}</HoldingsPopover>
                        };
                        return item;
                    }
                    case "InvestedValue": {
                        item = {
                            ...item,
                            comparator: sortingComparator,
                            cellRenderer: (props) => <HoldingsPopover placement={'left'} {...props}>{props.value}</HoldingsPopover>
                        };
                        return item;
                    }
                    default:
                        return {
                            ...item,
                        };
                }
            });
            if (!arrWatchlistColDefs?.find((column) => column?.field === 'detail')) {
                arrWatchlistColDefs?.unshift({
                    field: 'detail', headerName: "",
                    cellRenderer: 'agGroupCellRenderer',
                    width: '50',
                    maxWidth: 50,
                    detailCellRendererParams: { placement: 'right' },
                    pinned: 'left',
                    suppressMovable: true,
                    lockPosition: "left",
                    suppressNavigable: true,
                    menuTabs: [],
                    cellStyle: { display: "flex", alignItems: "center", justifyContent: "center" },
                    flex: 1
                },);
            }
            return arrWatchlistColDefs;
        } else { return []; }
    }, [holdingsTenantColumnProfiles, toggleTabs]);

    // Hari k:01-10-2024: changed column def according to manage columns - end


    // const handleCreateWatchlistButton = () => {
    //     handleCreateWatchlist(arrGridRowData);
    // };

    useEffect(() => {
        // Ameersha This will help to selct row navigate up and down by keybaord keys after changing Expand in Grid -- Start
        if (activePage) {
            if (toggleTabs) {
                setTimeout(() => {
                    const api = HOILDING_GRID_REF?.current?.api;
                    const columnApi = HOILDING_GRID_REF?.current?.columnApi;
                    const firstColId = columnApi.getAllDisplayedColumns()[1].getColId();
                    api.setFocusedCell(1, firstColId);
                }, 500);
            }
        }
        // Ameersha This will help to selct row navigate up and down by keybaord keys after changing Expand in Grid -- End
    }, [activePage, toggleTabs]);


    // Hari k:24-07-2024 : holdings-price volume view-start
    useEffect(() => {
        if (holdingsScrips?.length) {
            const updartedScripData = holdingsScrips?.map((each) => {
                return convertScripResponseWatchlistGrid(each.ScripData)[0];
            });
            setArrWatchlistData(updartedScripData);
        } else { }
    }, [holdingsScrips]);

    const handleViewDropDown = (value) => {
        if (value === "download") {
            dispatch(handleModal([{ "POSITION_REPORT": true }]));
        } else if (value === GRID_VIEW.MANAGE_COLUMNS_VIEW) { // dispatching this functins to open mange column modal
            dispatch(updateDefaultManageColumnName(DEFAULT_MANAGE_COLUMN_PROFILE_NAME.HOLDINGS));
            dispatch(updateStrViewType(MANAGE_COLUMNS_VIEW_TYPES?.HOLDINGS_VIEW_TYPE));
            dispatch(handleModal([{ "WATCHLIST_MANAGE_COLUMNS_MODAL": true }]));
        }
        else {
            if (value === GRID_VIEW.PRICE_VOLUME_VIEW) {
                const arrUnsubscridedScrips = arrGridRowData?.map((each) => ({
                    exchangeId: Number(each.nMarketSegmentId),
                    token: Number(each.nToken), isSubscribe: false
                }
                ));
                sendTouchlineRequest(arrUnsubscridedScrips);
            } else if (value === GRID_VIEW.DEFAULT_VIEW) {
                const arrSubscridedScrips = arrGridRowData?.map((each) => ({
                    exchangeId: Number(each.nMarketSegmentId),
                    token: Number(each.nToken), isSubscribe: true
                }
                ));
                sendTouchlineRequest(arrSubscridedScrips);
            } else { }
            dispatch(updateHoldingView(value));
        }
    };

    const handleWatchlistViewChange = () => {

        dispatch(updateHoldingView(GRID_VIEW.DEFAULT_VIEW));
    };
    // Hari k:24-07-2024 : holdings-price volume view-end
    // Vinit R : 26-07-2024 Open market overview modal -- Start

    const modalData = useSelector(state => state?.modals?.modalData);
    const modals = useSelector(state => state.modals.modals);

    //Ameersha N -- 28-08-2024 -- Subscription for visible scrips functionality --Start
    const handleVisibleRows = useCallback(() => {
        setObjScripsRequest(prevState => {
            let objpreviosScripsCopy = prevState;
            let arrWithKeys = [];
            let subscribeScrips = []; // This array is a non repeated subscrips for subscription
            let unSubScribeScrips = []; // this array is scrips of unsubscription]
            const arrVisibleRows = HOILDING_GRID_REF?.current?.api?.getRenderedNodes().map(item => {
                let id = item?.data?.nMarketSegmentId + "_" + item?.data?.nToken;
                arrWithKeys?.push(id);
                if (!objpreviosScripsCopy[id]) {
                    objpreviosScripsCopy[id] = true;
                    subscribeScrips?.push({ exchangeId: item?.data?.nMarketSegmentId, token: item?.data?.nToken, isSubscribe: true });

                }
                return { exchangeId: item?.data?.nMarketSegmentId, token: item?.data?.nToken, isSubscribe: true };
            });
            Object?.keys(objpreviosScripsCopy)?.forEach(key => {
                if (!arrWithKeys.includes(key)) {
                    let obj = {
                        exchangeId: Number(key?.split('_')[0]),
                        token: Number(key?.split('_')[1]),
                        isSubscribe: false
                    };
                    unSubScribeScrips?.push(obj);
                    delete objpreviosScripsCopy[key];
                }
            });
            //holdings doesnt have live data update
            sendTouchlineRequest(unSubScribeScrips);
            sendTouchlineRequest(subscribeScrips);
            return { ...objpreviosScripsCopy };
        });
    }, []);
    //Ameersha N -- 28-08-2024 -- Subscription for visible scrips functionality --End

    const onFirstDataRendered = useCallback((params) => { // Ameersha N --- this is grid functionality event when ever the data first load into dom this event weill be triggered we can use this on load instead of useEffect for neccessary functions
        handleVisibleRows();
    }, [handleVisibleRows]);

    const handleHoldingsScripsUnSubscription = useCallback(() => {
        handleScripUnsubScriptionOnUnMount(objScripsRequest, 'holdingsgrid');
    }, [objScripsRequest]);

    //Ameersha N-- unsubscribing of scrips when components unmounts of which scrips were send for subscription -- Start
    useUnload(() => {
        handleHoldingsScripsUnSubscription();
    });
    //Ameersha N-- unsubscribing of scrips when components unmounts of which scrips were send for subscription -- End
    const onGridPreDestroyed = useCallback((params) => {
        // this function gets called when the grdi before gets destroyed means getting removed from dom
        handleScripUnsubScriptionOnUnMount(objScripsRequest, 'watchlist');
    }, [objScripsRequest]);



    const headerText = {
        text: 'Holdings :', style: "header", fontSize: 14, color: '#426DD4', absolutePosition: { x: 40, y: 40 }
    };

    const onChangeToggleSector = (e) => {
        setHeatMapToggle(Number(e.target.checked));
        setActiveHoldings({});
        setArrHeatmap([]);
    };
    const convertedArrRowData = useMemo(() => {
        return arrGridRowData.map((each) => convertScripResponseWatchlistGrid(each.ScripData)[0]);
    });

    const defaultColProps = {
        minWidth: 180
    };
    return (
        <>
            <Container fluid className='p-0'>
                <Row className='g-0 mb-2 mx-3 align-items-center'>
                    <Col md={6} className='d-flex justify-content-start align-items-center'>
                        <div className='d-flex align-items-center'>
                            <div className='font-medium font-size6 color-text text-uppercase heading-border line-height-1 ps-3'>Holdings</div>
                            <BzToolTip placement='bottom' TooltipMsg={strHoldingMsg}>
                                <div className='p-2'>
                                    <span className='icon-16 icon-info icon-dark flex-shrink-0'></span>
                                </div>
                            </BzToolTip>
                        </div>
                    </Col>
                    <Col md={6}>
                        <Container fluid className='p-0'>
                            <Row className='g-0 justify-content-end align-items-center'>
                                <Col md='auto'>
                                    <span className='font-medium font-size2 color-text me-2'>Equity</span>
                                    <span className='font-regular font-size2 color-text'>({arrGridRowData?.length})</span>
                                </Col>
                                {/* Vinit R [19-07-2024] Remove heatmap view (temp- license issue) -- Start */}
                                <Col md='auto'>
                                    <Dropdown className='pt-1'>
                                        <Dropdown.Toggle as={CustomDropdownToggle}>
                                            <div className='icon-16 icon-kebab icon-dark flex-shrink-0 mx-2'></div>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item onClick={() => handleViewDropDown(GRID_VIEW.DEFAULT_VIEW)}>
                                                <div className='d-flex align-items-center'>
                                                    <Col md={6} className='d-flex align-items-center justify-content-start'>Default View</Col>
                                                    {holdingsView === GRID_VIEW.DEFAULT_VIEW && <Col md={6} className='d-flex justify-content-end'>
                                                        <div className='icon-16 icon-checktick icon-primary flex-shrink-0'></div>
                                                    </Col>}
                                                </div>
                                            </Dropdown.Item>
                                            {/* Hari k:12-11-2024 add manage colum option */}
                                            {
                                                holdingsView === GRID_VIEW.DEFAULT_VIEW ? <Dropdown.Item disabled={arrGridRowData?.length && holdingsView === GRID_VIEW.DEFAULT_VIEW ? false : true} onClick={() => handleViewDropDown('Manage Columns')}>
                                                    <div className='d-flex align-items-center'>
                                                        <Col md={6} className='d-flex align-items-center justify-content-start'>Manage Columns</Col>
                                                        {!GRID_VIEW.HEAT_MAP && GRID_VIEW.PRICE_VOLUME_VIEW && <Col md={6} className='d-flex justify-content-end'>
                                                            {/* <div className='icon-16 icon-checktick icon-primary flex-shrink-0'></div> */}
                                                        </Col>}
                                                    </div>
                                                </Dropdown.Item> : null
                                            }
                                            {/* Deepti B. [Breez-14] [23/10/2014]  heatmap view option will availble only on expand mode in holdings */}
                                            {toggleTabs && (
                                                <Dropdown.Item disabled={arrGridRowData?.length ? false : true} onClick={() => handleViewDropDown(GRID_VIEW.HEAT_MAP)}>
                                                    <div className='d-flex align-items-center'>
                                                        <Col md={6} className='d-flex align-items-center justify-content-start'>Heatmap View</Col>
                                                        {holdingsView === GRID_VIEW.HEAT_MAP && <Col md={6} className='d-flex justify-content-end'>
                                                            <div className='icon-16 icon-checktick icon-primary flex-shrink-0'></div>
                                                        </Col>}
                                                    </div>
                                                </Dropdown.Item>
                                            )}
                                            {
                                                !bIsProd() && toggleTabs ? <Dropdown.Item disabled={arrGridRowData?.length ? false : true} onClick={() => handleViewDropDown(GRID_VIEW.PRICE_VOLUME_VIEW)}>
                                                    <div className='d-flex align-items-center'>
                                                        <Col md={6} className='d-flex align-items-center justify-content-start'>Price / Volume View</Col>
                                                        {holdingsView === GRID_VIEW.PRICE_VOLUME_VIEW && <Col md={6} className='d-flex justify-content-end'>
                                                            <div className='icon-16 icon-checktick icon-primary flex-shrink-0'></div>
                                                        </Col>}
                                                    </div>
                                                </Dropdown.Item> : null
                                            }
                                            <Dropdown.Item disabled={arrGridRowData?.length ? false : true} onClick={() => handleViewDropDown("download")}>
                                                <div className='d-flex align-items-center'>
                                                    <Col md={6} className='d-flex align-items-center justify-content-start'>Download</Col>
                                                </div>
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </Col>
                                {/* Vinit R [19-07-2024] Remove heatmap view -- End */}
                                <Col md='auto'>
                                    <BzToolTip placement={'bottom'} TooltipMsg={'Expand Holdings'}>
                                        <button className='btn btn-sm expand-collapse-arrow' onClick={handleExpandHoldings}>{toggleTabs ? <div className='icon-16 icon-arrowleft icon-light flex-shrink-0'></div> : <div className='icon-16 icon-arrowright icon-light flex-shrink-0'></div>}</button>
                                    </BzToolTip>
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                </Row>
            </Container>
            <Row className='g-0'>
                <div className='d-flex align-items-center'>
                    {tempFilter?.length > 0 ? <div className='font-regular font-size4 color-text d-flex justify-content-center align-items-center p-3'>Filters:</div> : null}

                    {tempFilter?.filter(Boolean).map((te, i) => {
                        return (
                            <>
                                <div className='filters-chips-wrap'>
                                    <BzChip key={i} className='filter-chip me-2'>{te}<div onClick={() => handleDelete(te, i)} className='icon-10 icon-close icon-dark ms-2'></div></BzChip>
                                </div>
                            </>
                        );
                    })}
                </div>
            </Row>
            <div className='portfolio-right-grid-section'>
                {arrGridRowData?.length > 0 ?
                    (
                        holdingsView === GRID_VIEW.HEAT_MAP ?
                            // <HoldingsHeatmap toggleTabs={toggleTabs} heatMapToggle={heatMapToggle} setHeatMapToggle={setHeatMapToggle} activeButtonToggleIndex={activeButtonToggleIndex} setActiveButtonToggleIndex={setActiveButtonToggleIndex} heatmapChartConfig={heatmapChartConfig} isLoader={isLoader}  />
                            <HeatmapView
                                toggleTabs={toggleTabs} arrHeatmap={arrHeatmap} heatMapToggle={heatMapToggle}
                                setHeatMapToggle={setHeatMapToggle} isLoader={isLoader}
                                onChangeToggleSector={onChangeToggleSector} gridRef={HOILDING_GRID_REF}
                                handleWatchlistViewChange={handleWatchlistViewChange}
                                selectedScripData={arrWatchlistData}
                                activeButtonToggleIndex={activeButtonToggleIndex}
                            />
                            :
                            holdingsView === GRID_VIEW.PRICE_VOLUME_VIEW ?
                                <PriceVolumeView useDragHandle ref={HOILDING_GRID_REF}
                                    arrcombinedData={arrcombinedData} setArrcombinedData={setArrcombinedData}
                                    strSearchScrip={strSearchScrip} setStrSearchScrip={setStrSearchScrip}
                                    arrRowData={convertedArrRowData} arrWatchlistData={arrWatchlistData}
                                    isPortFolio={true} handleWatchlistViewChange={handleWatchlistViewChange}
                                />
                                :
                                <BzMasterAgGrid
                                    gridProfileType={MANAGE_COLUMNS_VIEW_TYPES?.HOLDINGS_VIEW_TYPE}
                                    isFirstDataRendered={onFirstDataRendered} defaultColProps={defaultColProps}
                                    onGridPreDestroyed={onGridPreDestroyed}
                                    gridKey={"holdings"} isCompress={true} arrColumnData={arrHoldingsColumnDefs}
                                    arrRowData={arrGridRowData} isMasterDetail={isMasterDetail}
                                    isSuppressMenu={isSuppressMenu} gridDetailCellRenderer={ExtendHoldings}
                                    rowHeight={36} className='ag-theme-alpine ag-theme-balham'
                                    ref={HOILDING_GRID_REF} getRowId={getHoldingssRowId}
                                    onBodyScroll={handleScrolling} rowClass='font-enlarge'
                                    isExternalFilterPresent={isExternalFilterPresent}
                                    doesExternalFilterPass={doesExternalFilterPass}
                                />
                    )
                    :
                    <div className='zero-state-alerts zero-state-alerts-xxl'>
                        <ZeroStates heading="Your holdings seems empty" subText="Place an order today."
                            icon='icon-64 icon-nodata mb-3 mrgauto'
                        />
                    </div>
                }
                {modals['WATCHLIST_SHARE_MODAL'] &&
                    <WatchlistShareModal columnDefs={arrHoldingsColumnDefs} rowData={arrGridRowData} gridRef={HOILDING_GRID_REF} headerName={"Share/Download Holdings"} fileName={"Holdings"} headerText={headerText} isShareLink={false} />}
            </div>
        </>
    );
};


export default memo(HoldingsGrid)

/*Mahesh S  : 05-10-2023 : BT-105135 -  Breeze- Portfolio Holdings - End*/